import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { SimService } from '../sim.service';
import { normalizeMsisdn } from '../sim.utils';

@Component({
  selector: 'mprd-sim-transfer',
  templateUrl: './sim-transfer.component.html',
})
export class SimTransferComponent {
  msisdn: string;
  showAndroidToaster = false;
  showIosToaster = false;
  showQrCode = false;
  activationCode$: Observable<string>;

  constructor(
    private route: ActivatedRoute,
    private simService: SimService,
  ) {
    this.msisdn = normalizeMsisdn(this.route.snapshot.params.msisdn);
    this.activationCode$ = this.simService.getActivationCode(this.msisdn);
  }
}
